import { useQuery } from "@tanstack/react-query";
import { http } from "../../utils";

export async function fetchBannerById(id) {
  const { data } = await http(`/admin/banners/${id}`);

  return data;
}

export function useBannerById(id) {
  const { data, ...raResult } = useQuery(["banner-detail", id], () =>
    fetchBannerById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
